import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductCategory.List.IRequest;
type Response = Api.Core.ProductCategory.List.IResponse;
type Headers = Api.Core.ProductCategory.List.IHeaders;
const url = '/api/ProductManagement/ProductCategory';
export default async function productCategoryListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
